import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSort as setSortAction } from "../../../actions/advancedListActions";
import { handleChangeAll as handleChangeAllAction } from "../../../actions/handleChangeAction";
import { getVedtaker as getVedtakerAction } from "../../../actions/klager/vedtakAction";
import UferdigstilteKlagesaker from "./UferdigstilteKlagesaker";

function UferdigstilteKlagesakerPage(ownProps) {
  const dispatch = useDispatch();
  const uferdigstilteKlagesaker = useSelector(
    (state) => state.uferdigstilteKlagesaker,
  );
  const uferdigstilteKlagesakerSubmittedForm = useSelector(
    (state) => state.submittedForms.uferdigstilteKlagesakerSubmittedForm,
  );

  const setSort = useCallback(
    (sort) => dispatch(setSortAction("UFERDIGSTILTEKLAGESAKER", sort)),
    [dispatch],
  );
  const getVedtaker = useCallback(
    (params) => dispatch(getVedtakerAction(params)),
    [dispatch],
  );
  const dispatchUferdigstilteKlagesaker = useCallback(
    (data) =>
      dispatch({
        type: "GET_ALL_UFERDIGSTILTE_KLAGESAKER_SUCCESS",
        payload: data,
      }),
    [dispatch],
  );
  const handleChangeAll = useCallback(
    (reducerName, payload) =>
      dispatch(handleChangeAllAction(reducerName, payload)),
    [dispatch],
  );

  return (
    <UferdigstilteKlagesaker
      {...ownProps}
      uferdigstilteKlagesaker={uferdigstilteKlagesaker}
      uferdigstilteKlagesakerSubmittedForm={
        uferdigstilteKlagesakerSubmittedForm
      }
      setSort={setSort}
      getVedtaker={getVedtaker}
      dispatchUferdigstilteKlagesaker={dispatchUferdigstilteKlagesaker}
      handleChangeAll={handleChangeAll}
    />
  );
}

export default UferdigstilteKlagesakerPage;
